import React from 'react'
import styled from 'styled-components'
import * as Options from './Options.js'
import MapButton from '../../components/MapButton.js'

const ModalContainer = styled.div`
    top: 63px;
    position: absolute;
    z-index: 999;
    background: #333333F0;
    left: 15px;
    width: ${props => props.mapSize - 30}px;
    height: ${props => props.mapSize - 30}px;
    color: white;
    display: relative;
    font-size: 1.2rem;
    overflow: hidden;

    h5 {
        font-size: 1.8rem;
    }

    ul {
        list-style-type: none;
    }

    @media (-moz-touch-enabled: 1), (pointer:coarse) {
        top: 15px;
    }
`

const OpenButton = MapButton.extend`
    top: 63px;
    right: 15px;

    @media (-moz-touch-enabled: 1), (pointer:coarse) {
        top: 15px;
    }
`

const CloseButton = MapButton.extend`
    top: 0px;
    right: 0px;
`

const HelpText = styled.div`
    padding: 20px;
    width: ${props => props.mapSize - 80}px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
    grid-row-gap: 20px;
`

class HelpModal extends React.PureComponent {
    state = { visible: false }

    toggleVisibility = () => { this.setState(({ visible }) => ({ visible: !visible })) }

    onKeydown = e => {
        if (e.keyCode === 191 && e.shiftKey) { // Question Mark
            this.toggleVisibility()
        }
    }

    componentDidMount() {
        window.addEventListener('keydown', this.onKeydown)
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.onKeydown)
    }

    /* eslint-disable max-len */
    render() {
        if (!this.state.visible) {
            return <OpenButton onClick={this.toggleVisibility}>?</OpenButton>
        }

        return (
            <Options.Context.Consumer>
                {({ options: { colors: { dot } } }) => (
                    <ModalContainer mapSize={this.props.mapSize} visible={this.state.visible}>
                        {this.state.visible &&
                            <HelpText mapSize={this.props.mapSize}>
                                <section>
                                    <h5>Genel Kullanım</h5>
                                    <ul>
                                        <li>Haritada yakınlaştırmak/uzaklaştırmak için scroll, kaydırmak için sürükle</li>
                                        <li>Noktaya veya roster satırına tıklayarak o oyuncunun isminin sabit görünmesini aç/kapat</li>
                                        <li>Oyuncu noktasında Shift+Tıklama: o oyuncu + takım arkadaşlarının isimlerini sabitle</li>
                                        <li>Takip edilen oyuncular roster’da altı çizili görünür</li>
                                        <li>Care package’ların üzerine gelerek içeriğini görüntüle</li>
                                        <li><strong>Haritanın yanındaki simgeler:</strong> (X daire) ölü oyuncuları göster/gizle; (liste) tüm isimleri göster/gizle; (işaretçi) deneme alanı — 1.–8. alan numarasını seçip kırmızı çerçeveyi haritada sürükleyebilirsiniz; (pusula) uçak rotasını göster/gizle — verilerden gelen rota çizgi üzerinde oklarla yönlü çizilir</li>
                                    </ul>
                                </section>

                                <section>
                                    <h5>Renkler</h5>
                                    <ul>
                                        <li style={{ color: dot.dead }}>Ölü</li>
                                        <li style={{ color: dot.knocked }}>Yerde (DBNO)</li>
                                        <li style={{ color: dot.enemy }}>Canlı</li>
                                        <li>Takım renkleri: her takım haritada kendi rengiyle gösterilir</li>
                                    </ul>
                                </section>

                                <section>
                                    <h5>Klavye Kısayolları</h5>
                                    <ul>
                                        <li>&lt;Space&gt;: Oynat / Duraklat</li>
                                        <li>&lt;Sol/Sağ oklar&gt;: Zamanda geri/ileri (adım = hız)</li>
                                        <li>&lt;Yukarı/Aşağı oklar&gt;: Oynatma hızını artır/azalt</li>
                                        <li>&lt;?&gt;: Bu yardım ekranını aç/kapat</li>
                                    </ul>
                                </section>

                                <section>
                                    <h5>Bilgi</h5>
                                    <ul>
                                        <li>Maçlar genelde bittikten yaklaşık 10 dakika sonra yüklenebilir</li>
                                        <li>Oyuncu canı, noktadaki dairenin dolu yüzdesiyle gösterilir</li>
                                        <li>Araçtaki oyuncular direksiyon ikonu ile işaretlenir</li>
                                        <li>Uçak rotası maç verisinden (PlaneStart/PlaneStop) alınır; başlangıçta daire, bitişte ve çizgi üzerinde ok ile yön gösterilir</li>
                                    </ul>
                                </section>
                            </HelpText>
                        }
                        <CloseButton onClick={this.toggleVisibility}>X</CloseButton>
                    </ModalContainer>
                )}
            </Options.Context.Consumer>
        )
    }
    /* eslint-enable max-len */
}

export default HelpModal




// WEBPACK FOOTER //
// ./src/components/MatchPlayer/HelpModal.js